import React, { useState } from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import AppointmentCalendar from '../../components/AppontmentCalendar';

import ForApprovalMedRepList from './components/ForApprovalMedRepList';
import AppointmentStatTable from './components/AppointmentStatTable';
import AppointmentListModal from './components/AppointmentListModal';

export default function ForApproval() {
  const [loading, setLoading] = useState(false);

  const [appointmentModal, setAppointmentModal] = useState({
    toggle: false,
    data: [],
  });
  const [appointments, setAppointments] = useState({
    data: [],
    totalRows: 0,
  });

  // eslint-disable-next-line no-unused-vars
  const [appointmentParams, setAppointmentParams] = useState({
    approval_id: 1,
    currentDate: moment().add(1, 'months').format('YYYY-MM-DD'), // .add(1, 'months')
    date: moment().add(1, 'months').format('YYYY-MM'), //
  });

  const [appointmentStatParams, setAppointmentStatParams] = useState({
    rep_id: '',
    date: moment().add(1, 'months').format('YYYY-MM'), // .add(1, 'months')
    date_submitted: '',
  });

  const handleChangeDate = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const handleOnClickSpecialist = ({ data, totalRows, selectedRow }) => {
    if (selectedRow?.unique_id) {
      setAppointmentStatParams({
        ...appointmentStatParams,
        date: appointmentParams.date,
        rep_id: selectedRow.unique_id,
        date_submitted: selectedRow.date_scheduled,
      });
    }

    setAppointments({
      ...appointments,
      data: data.map((row) => ({
        ...row,
        date: row.date_scheduled,
        date_time: `${row.date_scheduled} ${row.time_scheduled}`,
      })),
      totalRows,
    });
  };

  const handleShowMore = (data) => {
    setAppointmentModal({ ...appointmentModal, toggle: true, data: data.appointments });
  };

  const handleAppointmentModalClose = () => {
    setAppointmentModal({ ...appointmentModal, toggle: false, data: [] });
  };

  const handleChangeMonth = (value) => {
    setAppointmentParams({
      ...appointmentParams,
      date: moment(value).format('YYYY-MM'),
      currentDate: moment(value).format('YYYY-MM-DD'),
    });
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Stack direct='row' spacing={2} sx={{ mb: 3 }}>
          <div>
            <DatePicker
              label='"month" and "year"'
              views={['month', 'year']}
              value={appointmentParams.currentDate === '' ? null : appointmentParams.currentDate}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Month' size='small' />}
              onChange={handleChangeMonth}
            />
          </div>
        </Stack>
        <Grid container spacing={2}>
          <Grid xs={6}>
            <Typography variant='h6' sx={{ mb: 2 }}>
              CWP For Approval
            </Typography>

            <div style={{ marginBottom: 3, position: 'relative' }}>
              <ForApprovalMedRepList
                selectedYearMonth={appointmentParams.date}
                onClickSpecialist={handleOnClickSpecialist}
              />
            </div>
          </Grid>
          <Grid xs={6}>
            <Box sx={{ mb: 3 }}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Calendar with MD Name
              </Typography>
              <AppointmentCalendar
                appointments={appointments.data}
                onChangeDate={handleChangeDate}
                loading={loading}
                onShowMore={handleShowMore}
                initDate={appointmentParams.date}
              />
            </Box>
          </Grid>
          <Grid xs={6}>
            <Box sx={{ mb: 3 }}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Calendar with Scheduled Appointments
              </Typography>
              <AppointmentCalendar
                initDate={appointmentParams.date}
                appointments={appointments.data}
                isCount
                loading={loading}
                onShowMore={handleShowMore}
              />
            </Box>
          </Grid>
          <Grid xs={6}>
            <Typography variant='h6' sx={{ mb: 2 }}>
              Scheduled Appointment per MD
            </Typography>
            <div style={{ marginBottom: 3, position: 'relative' }}>
              <AppointmentStatTable
                approvalId='2'
                repId={appointmentStatParams.rep_id}
                date={appointmentStatParams.date}
                dateSubmitted={appointmentStatParams.date_submitted}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
      <AppointmentListModal
        toggle={appointmentModal.toggle}
        data={appointmentModal.data}
        onClose={handleAppointmentModalClose}
      />
    </>
  );
}
